module.exports = __webpack_public_path__ + "static/img/cont3613.04cc6c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3613.jpg
// module id = 6tGs
// module chunks = 0